import VerticalLinearStepper from "../VerticalLinearStepper";
import { TableData } from "../TableData";

export const KdappontLesson8 = () => {
  const tableData = {
    head: ["Instructies"],
    body: [
      [
        "🖥️ Claim 2 werkplekken - Zorg dus voor minstens 1 stoel tussen jou en je buurman.",
      ],
      [
        "⏱️ Voor deze toetsen krijg je 120 minuten de tijd. Een kleine uitloop tot 17:30 is mogelijk.",
      ],
      [
        "🤐 Je werkt individueel. Overleg is niet toegestaan en we werken in stilte.",
      ],
      ["📄 Lever je theorietoets in vóórdat je aan de praktijktoets begint."],
      [
        "🧭 Instructies voor de praktijktoets vind je onder Digitaal Lesmateriaal -> KDAPPONT -> 👉 LES 8 - Toets",
      ],
      [
        "🚫 Je mag enkel gebruik maken van het digitale lesmateriaal van KDAPPONT. Linkjes die naar W3Schools verwijzen mag je ook gebruiken.",
      ],
      [
        "📦 Lever je praktijktoets als een ZIP / Archief bestand in, in de KDAPPONT2 Teams inleverbox",
      ],
      ["🏁 Ben je klaar? Dan mag je gaan."],
    ],
  };
  return (
    <VerticalLinearStepper
      steps={[
        {
          label: "🤫 HTML Theorie & Praktijk toets",
          description: "",
          content: <TableData data={tableData} />,
        },
      ]}
    />
  );
};
